/**
 * mwApp.drm module <br>
 * Work with settings
 *
 * @namespace mwApp/drm
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/drm
 * @see mwApp/drm
 *
 * @ngdoc config
 * @name mwApp/drm.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /drmaccounts
     */
    .state('app.drmaccounts', {
      abstract: true,
      url: '/drmaccounts',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/drm.controller:DRMAccountsCtrl}
     * @name /drmaccounts
     * @memberof mwApp/drm.config:ConfigRoutes
     */
    .state('app.drmaccounts.list', {
      url: '',
      templateUrl: 'components/drm/views/drmAccounts.html',
      controller: 'DRMAccountsCtrl as vm',
      label: 'DRM Accounts',
      access: 'viewDRMAccount'
    })

    /**
     * abstract state for /:drmAccountId
     */
    .state('app.drmaccounts.account', {
      abstract: true,
      url: '/:drmAccountId',
      template: '<ui-view/>',
      resolve: {
        account: /* @ngInject */ function ($transition$, DRMAccount) {
          var { drmAccountId: id } = $transition$.params()
          return +id
            ? DRMAccount.load({ id })
            : new DRMAccount()
        }
      }
    })

    /**
     * controller {@link mwApp/drm.controller:AddDRMAccountCtrl}
     * @name /drmaccounts/:drmAccountId
     * @memberof mwApp/drm.config:ConfigRoutes
     */
    .state('app.drmaccounts.account.edit', {
      url: '',
      templateUrl: 'components/drm/views/addDRMAccount.html',
      controller: 'AddDRMAccountCtrl as vm',
      label: '{{::drmAccountId | addOrEdit}} DRM Account',
      access: ':drmAccountId (+) ! IF createDRMAccount ELSE editDRMAccount'
    })
}
